import { es } from 'date-fns/locale/es';
import { isEqual } from 'lodash';
import moment from 'moment';
import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSelect from '../../../components/forms/CustomSelect';
import { DatePicker } from '../../../components/forms/DatePicker';
import FormLabel from '../../../components/forms/FormLabel';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import useDepartments from '../../../hooks/api-calls/useDepartments';
import useUserNetworks from '../../../hooks/api-calls/useUserNetworks';
import useUsers from '../../../hooks/api-calls/useUsers';
import { FilterOptions } from '../../../hooks/useFilters';

interface UsersRankingsFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const UsersRankingsFilters: React.FC<UsersRankingsFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    const { userCan } = usePrivilege();
    const { fetchUsers, getUsersList } = useUsers();
    const { getDepartmentsList } = useDepartments();
    const { getUserNetworksList } = useUserNetworks();

    return (
        <>
            {/* <CustomSearchableEntities
                id="commercials"
                label="Comercial"
                filters={filters}
                updateFilters={updateFilters}
                fetchOptions={async (searchText: string | null) => {
                    return fetchUsers({ search_text: searchText, ids: filters.filter_filters?.commercials ?? [] });
                }}
            /> */}

            {userCan('get_users_for_select', 'user') && (
                <CustomSelect
                    id="commercials"
                    label="Comercial"
                    isMulti
                    options={getUsersList()}
                    value={filters.filter_filters?.commercials ?
                        getUsersList().filter((type) => filters.filter_filters?.commercials?.includes(type.value)) : []}
                    onChange={(value: { value: string, label: string }[]) => {
                        const values = value.map((type) => type.value);
                        if (values !== filters.filter_filters?.commercials) {
                            updateFilters({ commercials: values });
                        }
                    }}
                />
            )}

            <CustomSelect
                isSearchable
                isMulti
                id={'commercial_networks'}
                label="Redes Comerciales"
                options={getUserNetworksList()}
                onChange={(e: any) => { updateFilters({ commercial_networks: e.map((network: any) => network.value) }) }}
                value={
                    filters.filter_filters?.commercial_networks
                        ? getUserNetworksList().filter((network: any) => filters.filter_filters?.commercial_networks.includes(network.value))
                        : []
                }
                display={userCan('list_commercial_network', 'commercial_network') && userCan('view_contract_points_history', 'contracts')}
            />

            <CustomSelect
                isSearchable
                isMulti
                id={'departments'}
                label="Departamentos"
                options={getDepartmentsList()}
                onChange={(e: any) => { updateFilters({ departments: e.map((d: any) => d.value) }) }}
                value={
                    filters.filter_filters?.departments
                        ? getDepartmentsList().filter((d: any) => filters.filter_filters?.departments.includes(d.value))
                        : []
                }
                display={userCan('list_departments', 'departments')}
            />

            <div>
                <FormLabel label="Fecha personalizada" />
                <DatePicker
                    isClearable
                    placeholderText="Selecciona fecha"
                    className="w-full"
                    selected={filters.filter_filters?.customDate ? new Date(filters.filter_filters.customDate) : null}
                    onChange={(date: Date | null) => {
                        const filters_customDate = filters.filter_filters?.customDate;
                        const customDate = date ? moment(date).format('YYYY-MM-DD') : null;
                        if (customDate && !isEqual(filters_customDate, customDate)) {
                            updateFilters({ customDate: customDate });
                        } else if (!customDate && filters_customDate) {
                            updateFilters({ customDate: null });
                        }
                    }}
                    onClear={() => updateFilters({ customDate: null })}
                    locale={es}
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                />
            </div>

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </>
    );
};

export default UsersRankingsFilters;